const NON_EDITABLE_FIELDS = ['OUTPUT'];

const hasError = (collection) =>
  Object.keys(collection).filter((key) => {
    if (
      collection[key].hidden ||
      collection[key].clientId === 'appRequest_linkedPaymentCard_cardNetwork' ||
      /** Hack: again shouldn't be implementing this as a field */
      collection[key].clientId === 'appRequest_recaptcha'
    ) {
      return false;
    }
    if (NON_EDITABLE_FIELDS.includes(collection[key].fieldType)) {
      return false;
    }
    return collection[key].error;
  }).length > 0;

export default hasError;
